import CompanyPage from './CompanyPage';

export default CompanyPage;
